export default __webpack_public_path__ + "static/media/buyNft.5d3d475e.png";